import $ from "cash-dom";
import web from "@old/utils/url-resolver";
import gaSC from "@common/utils/ga";
import smoothscroll from "smoothscroll";
import { goRedirectionInit } from "../@common/events/go-redirection";
import { request, apiBase } from "@common/request";
import { ShowAlert } from "@common/utils/alert";
import MainLeaderBoard from "./Partials/leaderBoard";
import setTimeoutAsync from "@common/utils/set-timeout";
import Cookie from 'js-cookie';
import { openLoginModal, isLoggedIn } from '@common/headers/login';
import { grabOnInit } from '@core';

/* Error Flag */
var MerchantError = false,
    MerchantErrorHtml,
    MerchantErrorParent,
    CouponError = false,
    CouponErrorHtml,
    CouponErrorParent,
    NewMerchantErrorHtml,
    NewMerchantErrorParent,
    MerchantURLHtml,
    MerchantURLParetnt,
    SortMerchants,
    MerchantSearchText,
    MerchantId,
    MobileNumberErrorParent,
    EmailErrorParent,
    MobileNumberError,
    MobileNumberErrorHtml,
    EmailErrorHtml,
    EmailError,
    sortMerchants = false;

class CrowdSourcing {
    CouponSubmission = true;
    MerchantSubmission = false;
    WeekFilter = true;
    MonthFilter = false;
    Submissions = [
        {
            name:'Coupon Submission',
            id:1
        },
        {
            name:'Merchant Submission',
            id:2
        }
    ]
    DateFilters = [
        {
            name:'Week',
            id:1
        },
        {
            name:'Month',
            id:2
        }
    ]

    couponSubmission = (target) => {
        $('#crowdHead').attr('data-type', 'coupon');
        $('#crowdHead > h1').html("Submit Coupon")
        this.CouponSubmission = true;
        this.MerchantSubmission = false;
        $('.submitTab').removeClass('active');
        $(`#${target}`).addClass('active');
        this.formClear(target);
        $('.ErrorSpan').html('');
    }

    merchantSubmission = (target,merchantName = '') => {
        $('#crowdHead').attr('data-type', 'merchant');
        $('#crowdHead > h1').html("Submit Merchant")
        this.MerchantSubmission = true;
        this.CouponSubmission = false;
        $('.submitTab').removeClass('active');
        $(`#${target}`).addClass('active');
        $('#NewMerchantName').val(merchantName);
        if(merchantName === ''){
            this.formClear(target)
        }
        $('.ErrorSpan').html('');
        MobileNumberError = false;
        EmailError = false;

    } 

    weekFilter = () => {
        this.WeekFilter = true;
        this.MonthFilter = false;
    }

    monthFilter = () => {
        this.MonthFilter = true;
        this.WeekFilter = false;
    }

    showError = (html, parent$) => {
        
        if (parent$ != undefined) {
            parent$.find('.ErrorSpan').addClass('active');
            parent$.find('.ErrorSpan').html(html);
        }
    }
    removeError = (parent$) => {
        
        if (parent$ != undefined) {
            parent$.find('.ErrorSpan').removeClass('active');
            parent$.find('.ErrorSpan').html('');
        }
    }
    formClear = (target) => {
        let form = $(`#${target}`).find('.form-control')
        form.val('');
    }
    focusElement = (target) => {
        document.querySelector(`#${target}`).animate({
            scrollTop: 150
        }, 1000)
        document.getElementById(`${target}`).focus();
    }

    submissionDesc = (index ) =>{
        let html = `
                    <div class="submissionInfo">
                        <div>
                            <h2 data-type="has-underline">
                                ${index == 0 ? "Coupon Submission Instructions" : "Merchant Submission Instructions"}
                            </h2>
                            <h3>
                                ${index == 0 ? "Submit a coupon code and help the whole community save more!" : "Suggest a missing merchant, and we will add coupons & deals for it!"} 
                            </h3>
                        </div>
                        <div>
                            <h4>
                                ${index == 0 ? "Coupon" : "Merchant"} Submission Guidelines
                            </h4>
                            ${index == 0 ? "<ul><li>Submit only publicly available coupon codes (avoid private or internal company codes).</li><li>Take permission from the merchant first when in doubt.</li><li>Wait for a few days to know about your coupon acceptance status.</li></ul>" : "<div>Only submit missing merchants. Search our website, or type merchant name coupons grabon, to verify that. The final decision to add a merchant to our coupons database lies with our team, so in case your submission is not accepted, dont be disheartened. </div>"}
                        </div>
                        <div>
                            <h4>
                                Benefits of ${index == 0 ? "coupons" : "merchants"} submission:
                            </h4>
                            <ul class="no-list">
                                <li>
                                    <strong>Get Recognized</strong>
                                    <br>
                                    Earn points, badges and climb the leaderboard for every accepted ${index == 0 ? "coupon" : "merchant"} submission.
                                </li>
                                <li>
                                    <strong>Be a Part Of Something Big</strong>
                                    <br>
                                    Help millions of shoppers save more ${index == 0 ? "through your exclusive promo codes" : "across their favorite merchants!"}.
                                </li>
                                <li>
                                    <strong>Win Cool Stuff</strong>
                                    <br>
                                    Be amongst the first one to receive community-exclusive prizes!
                                </li>
                            </ul>
                        </div>
                    </div>  
        `;

        $('.submissionDesc').html(html);
    }

    changeTableHeight = (target) => {
        let tabHeight = $(`#${target}`).innerHeight();
        $('#leaderBoardBody').css({
            'max-height':`${tabHeight}px`
        })
    }

}

var merchants = [];
/** Resolves once the merchant list has landed — see the fetch in $(async …). */
var merchantsReady = Promise.resolve([]);
var submitFormHeight;

// var rs = getComputedStyle(r);

$()
$(async () => {
    // THE MERCHANT LIST. .in calls its own `GetCategory`; this gateway's
    // merchant list is `/stores?categoryType=Merchant` — the same call the
    // listing pages make. Rows are mapped into .in's {CategoryID, CategoryName}
    // shape, so every SearchMerchants / SortedMerchants / filteredMerchants
    // call below keeps working unchanged.
    //
    // NOT AWAITED HERE. That response is 2,435 merchants and ~2.6 MB, and the
    // endpoint whitelists its query so it cannot be narrowed (an added `limit`
    // is a 400, not a smaller answer). Awaiting it before grabOnInit() would
    // hold the whole page on a download only the autocomplete needs, so the
    // promise is kept and awaited at the two places that read `merchants`.
    merchantsReady = request
        .get(apiBase() + '/stores?categoryType=Merchant')
        .then((res) => {
            merchants = ((res && res.stores) || []).map((row) => ({
                CategoryID: row.id,
                CategoryName: row.displayName || row.name || '',
            }));
            return merchants;
        });


    let index = Cookie.get('index');
    if (index != undefined) {
        if (index === '0') {
            activeTabs(parseInt(index));
            crowdSourcing.couponSubmission('couponSubmssion');
        }
        else {
            activeTabs(parseInt(index));
            crowdSourcing.merchantSubmission('merchantSubmssion');
        }
    }
    else {
        activeTabs(0);
    }
    //activeTabs(0);
    grabOnInit();
    goRedirectionInit();
    crowdSourcing.submissionDesc(0);
    crowdSourcing.changeTableHeight('couponSubmssion');
    // leaderBoardSorting();
    // filterTabs(0);
    // MainLeaderBoard.filterTabs(0);
    var dd = String(new Date().getDate()).padStart(2, '0');
    var mm = String(new Date().getMonth() + 1).padStart(2, '0');
    var yyyy = new Date().getFullYear();

    var today = yyyy + '-' + mm + '-' + dd;
    $('#expirydate').attr('min',today);
})

let crowdSourcing = new CrowdSourcing();
let Submissions = [...crowdSourcing.Submissions];
const subUL = $('#btnUl');
const merchantUL = $('#filteredMerchantsUL');


/* Active Tab */

const activeTabs = (ClickIndex) => {
    const html = Submissions.map((e,index) => {
        return `<li class='${ClickIndex == index ? 'active':''} btnLi' data-id='${index}' data-target='${index == 0 ? 'couponSubmssion':'merchantSubmssion'}'>${e.name}</li>`
    }).join('')
    
    subUL.html(html);
}

/* Tabs Coupon/Merchant Submission */

$('body').on('click','.btnLi',(e) => {
    let index = e.target.getAttribute('data-id');
    let target = e.target.getAttribute('data-target');
    activeTabs(index);
    crowdSourcing.submissionDesc(index);
    switch(target) {
        case 'couponSubmssion':
            crowdSourcing.couponSubmission(target);
            break;
        
        case 'merchantSubmssion':
            crowdSourcing.merchantSubmission(target);
            break;
    }

    crowdSourcing.changeTableHeight(target);
})


/* Else Any Where Function */

$(document).on('click',(event) => {
    if (!$(event.target).closest('.merchantRow').length) {
        merchantUL.html('')
        $('.filteredMerchants').removeClass('active');
      }
})

/* Search Merchants with input value */
const filteredMerchants = (merchants, searchValue) => {
    
    let html = '';
    $('.filteredMerchants').addClass('active');
    if(merchants === 0){
        merchantUL.html('')
        $('.filteredMerchants').removeClass('active');
        return;
    }
    if (merchants.length == 0) {
        // html =  `<li class='text-center'>
        //             <img src='https://cdn.grabon.in/dev/gograbon/test/noResutsFound.gif' alt='No Results Found' />
        //             <span>No Results Found</span>
        //         </li>`
        // return html;
        merchantUL.html('')
        $('.filteredMerchants').removeClass('active');
        html = `<span>Does not exists with <span class='searchValueSpan'>'${searchValue}'</span>, if you want to submit this merchant click 
        <a class="merchatLink" href='javascript:void(0)' data-target='${searchValue}'>here</a></span>`;
        return html;
        
    }   
    else{
        html = merchants.map((merchant) => {
            return `<li data-id='${merchant.CategoryID}' data-name='${merchant.CategoryName}' class='merchantLi'>${merchant.CategoryName}</li>`
        }).join(' ');
        return html;
    }
}

/* FilterMerchants */
const SearchMerchants = (inputValue) => {
    let newMerchants = merchants.filter((merchant) => {
        return merchant.CategoryName.toLowerCase().includes(inputValue.toLowerCase())
    });
    return newMerchants
}

/* SortMerchants */
const SortedMerchants = (inputValue) => {
    let sortedMerchants = merchants.some((merchant) => {
        return merchant.CategoryName.toLowerCase() === inputValue.toLowerCase();
    });
    return sortedMerchants;
}



$('body')
    /* Coupon Form Submission Event */
    .on('submit', '#cs-form', async (event) => {
        if (Cookie.get('index')) {
            Cookie.remove('index');
        }        
        Cookie.set('index','0');
        let couponSubmitButtonParent$ = $("#couponSubmitButtonRow");
        let target = event.target.getAttribute('id');
        event.preventDefault();
        var filtermerchant = $('#filteredMerchantsUL');
        var searchMerchant = $('#searchMerchant').val().toString();
        //crowdSourcing.removeError(couponSubmitButtonParent$);
        MerchantErrorParent = filtermerchant.parent().parent();
        crowdSourcing.removeError(MerchantErrorParent);
        crowdSourcing.removeError(CouponErrorParent);
        crowdSourcing.removeError(couponSubmitButtonParent$);
        // isLoggedIn(), NOT Cookie.get('twentyfour'). That is India's session
        // cookie and this backend never sets it, so the read was always
        // undefined and every visitor — signed in or not — got the login popup
        // instead of submitting. login.js owns the cookie names; nothing else
        // should name them.
        //
        // The gate itself is .in's choice, kept deliberately: International's
        // submit page has no auth gate and POST /submissions/coupon accepts an
        // anonymous body (verified — {title:'x'} with no Authorization is a
        // 201). Remove these two blocks to match International instead.
        if (!isLoggedIn()) {
            openLoginModal();
            return;
        }
        if (!SortMerchants) {
            MerchantError = true;
            MerchantErrorHtml = filteredMerchants([], searchMerchant);
            crowdSourcing.showError(MerchantErrorHtml, MerchantErrorParent);
            crowdSourcing.focusElement('searchMerchant');
            return;
        }
        if (MerchantError){
            crowdSourcing.showError(MerchantErrorHtml,MerchantErrorParent);
            crowdSourcing.focusElement('searchMerchant');
        }
        if(CouponError){
            crowdSourcing.showError(CouponErrorHtml, CouponErrorParent)
            crowdSourcing.focusElement('couponText');

        }
        if (!CouponError && !MerchantError && SortMerchants) {
            var couponCode = $("#couponText").val().toString();
            var startdate = $("#startdate").val().toString();
            var expirydate = $("#expirydate").val().toString();
            var tc = $("#tc").val().toString();
            var title = $("#title").val().toString();
            var description = $("#description").val().toString();
            await merchantsReady;
            if (MerchantId == 0 && SortMerchants) {
                let getMerchant = merchants.filter((merchant, index) => {
                    return merchant.CategoryName.toString().toLowerCase() == searchMerchant.toLowerCase();
                }).map(merchant => merchant.CategoryID)
                MerchantId = getMerchant.toString();
            }
            // POST /submissions/coupon — the field names are International's
            // and are NOT .in's renamed: `categoryId` (the merchant), `code`,
            // `termsAndConditions`. `UserID` is gone because the gateway takes
            // the submitter from the token, not the body.
            //
            // `startDate` has no .in equivalent at all — its form only collects
            // an expiry. The field was added to the view for this.
            // EMPTY OPTIONAL FIELDS ARE OMITTED, NOT SENT BLANK. Verified
            // against the gateway: `{categoryId:'', startDate:'',
            // expiryDate:''}` answers 400 with "categoryId must be a UUID" and
            // "must be a valid ISO 8601 date string". An untouched date input
            // returns '' and MerchantId is the number 0 when nothing matched,
            // so sending the whole shape unconditionally would reject every
            // submission that left a field blank. Only `title` is required.
            var json = { title: title };
            if (couponCode) json.code = couponCode;
            // `MerchantId` is 0 / '' until a merchant is picked from the
            // autocomplete; the gateway wants a uuid or nothing.
            if (MerchantId && /^[0-9a-f-]{36}$/i.test(String(MerchantId))) {
                json.categoryId = String(MerchantId);
            }
            // <input type="date"> yields YYYY-MM-DD, which is valid ISO 8601.
            if (startdate) json.startDate = startdate;
            if (expirydate) json.expiryDate = expirydate;
            if (description) json.description = description;
            if (tc) json.termsAndConditions = tc;
            var data = await request.post(apiBase() + '/submissions/coupon', json);
            // .in's route answers a bare `true`/`false`; this one answers
            // `{success, message}`. Testing the object for truthiness would
            // read every rejection as a success, because `{success:false}` is
            // itself truthy.
            if (data && data.success) {
                const html = 'Thanks for submitting your coupon. It will be posted after a quick review.'
                crowdSourcing.removeError(MerchantErrorParent);
                crowdSourcing.removeError(CouponErrorParent);
                crowdSourcing.removeError(couponSubmitButtonParent$);
                crowdSourcing.formClear(target);
                // (message, {type}) — this repo's signature. .in passes a title, an
                // India-CDN image and a flag; that image is not mirrored here and
                // the extra args are silently ignored, so the toast showed a
                // broken icon.
                ShowAlert(html);
                setTimeout(() => {
                    crowdSourcing.formClear(target);
                }, 1000);
                gaSC('Submit A Coupon','Coupon Submission');
            }
            else {
                // Prefer the gateway's own message — .in had none to show, so
                // it guessed at the reason. Its guess stays as the fallback.
                CouponErrorHtml = (data && data.message)
                    || "Either You have already submitted Coupon or it is already exist!";
                crowdSourcing.showError(CouponErrorHtml, couponSubmitButtonParent$);
            }
        }
    })
    /* Search Merchant Keyup Event */
    .on('keyup','#searchMerchant',async (e) => {
        // The list is fetched at load but not awaited there — the first
        // keystroke can land before 2.6 MB has arrived, and filtering an empty
        // array would tell the visitor their merchant does not exist.
        await merchantsReady;
        const thisParentClass = e.target.parentElement.parentElement.className;
        const thisParent$ = $(`.${thisParentClass}`);
        const searchText = e.target.value;
        let newMerchants = SearchMerchants(searchText);
        var searchMerchant = $('#searchMerchant').val().toString();
        SortMerchants = SortedMerchants(searchText);
        if(searchText == ''){
            filteredMerchants(0);
            crowdSourcing.removeError(thisParent$)
            MerchantError = false;
            MerchantId = 0;

        }

        if(searchText != ''){
            if(newMerchants.length == 0){
                MerchantErrorHtml = filteredMerchants(newMerchants, searchText);
                MerchantErrorParent = thisParent$;
                // crowdSourcing.showError(span,thisParent$);
                MerchantError = true;
                MerchantId = 0;
                // return span;
                MerchantErrorHtml = filteredMerchants([], searchMerchant);
                crowdSourcing.showError(MerchantErrorHtml, MerchantErrorParent);
                crowdSourcing.focusElement('searchMerchant');
            }
            else{
                crowdSourcing.removeError(thisParent$);
                let ul = filteredMerchants(newMerchants, searchText)
                merchantUL.html(ul);
                MerchantError = false;
                MerchantId = 0;
            }
        }
    })
    /* New Merchant Redirection */
    .on('click','.merchatLink',(e) => {
        let merchantName = e.target.getAttribute('data-target')
        crowdSourcing.merchantSubmission('merchantSubmssion',merchantName);
        activeTabs(1)
    })
    /* Merchant click event */
    .on('click','.merchantLi',(e) => {
        let merchantName = e.target.getAttribute('data-name')
        MerchantId = e.target.getAttribute('data-id');
        MerchantSearchText = merchantName;
        SortMerchants = SortedMerchants(merchantName);
        $('#searchMerchant').val(merchantName);
        $('.filteredMerchants').removeClass('active');
        merchantUL.html('')
    })
    /* Coupon Code input */
    .on('keyup','#couponText',(e) => {
        const thisParentClass = e.target.parentElement.className;
        const thisParent$ = $(`.${thisParentClass}`);
        let couponText = e.target.value;
        if(couponText.length < 0){
            CouponErrorHtml = `Enter Vaild code. Please double check and try again`
            CouponError = true;
            CouponErrorParent = thisParent$;
        }
        else{
            crowdSourcing.removeError(thisParent$);
            CouponError = false;
        }
    })

    /* Merchant Form Submission Event */
    .on('submit', '#ms-form', async (event) => {        
        if (Cookie.get('index')) {
            Cookie.remove('index');
        }
        Cookie.set('index', '1');
        let submitButtonParent$ = $("#submitButtonRow");
        let target = event.target.getAttribute('id');
        var name = $("#NewMerchantName").val().toString();
        var merchantURL = $('#MerchantUrl');
        var email = $('#emailaddress').val().toString();
        var mobileNumber = $('#mobileNumber').val().toString();
        event.preventDefault();
        crowdSourcing.removeError(NewMerchantErrorParent);
        crowdSourcing.removeError(MerchantURLParetnt);
        crowdSourcing.removeError(submitButtonParent$);
        // See the coupon submit above for why this is isLoggedIn().
        if (!isLoggedIn()) {
            // .in stashes the two fields so the form can be restored after the
            // login round-trip. Nothing in this repo reads them back yet —
            // kept because the popup does reload the page, so restoring is a
            // read away rather than a rewrite.
            Cookie.set('merchantname', name);
            Cookie.set('merchanturl', merchantURL.val().toString());
            openLoginModal();
            return;

        }
        let MerchantName = $('#NewMerchantName');
        const isExisted = merchants.some((merchant)=>{
            return merchant.CategoryName.toLowerCase() === MerchantName.val().toString().toLowerCase();
        });

        NewMerchantErrorParent = MerchantName.parent().parent();

        if(isExisted){
            NewMerchantErrorHtml = `'${MerchantName.val()}' Already Exists. Please Submit New Merchant`
            crowdSourcing.showError(NewMerchantErrorHtml,NewMerchantErrorParent);
            MerchantName.trigger('focus');
            return;
        }

        if (merchantURL.val().toString().indexOf('http') == -1 || merchantURL.val().toString().indexOf('https') == -1) {
            crowdSourcing.removeError(submitButtonParent$);
            MerchantURLHtml = `Invalid URL. Please Enter URL with http or https`;
            MerchantURLParetnt = merchantURL.parent();
            crowdSourcing.showError(MerchantURLHtml, MerchantURLParetnt);
            merchantURL.trigger('focus');
            return;
        }
        if (EmailError) {
            crowdSourcing.showError(EmailErrorHtml, EmailErrorParent)
            crowdSourcing.focusElement('emailaddress');
            return;
        }
        if (MobileNumberError) {
            crowdSourcing.showError(MobileNumberErrorHtml, MobileNumberErrorParent)
            crowdSourcing.focusElement('mobileNumber');
            return;
        }
        await setTimeoutAsync(200)
        crowdSourcing.removeError(NewMerchantErrorParent);
        crowdSourcing.removeError(MerchantURLParetnt);
        // POST /submissions/merchant takes the four fields under
        // International's names. `website` is the URL AS TYPED, not the bare
        // domain .in extracts — .in sends both and uses the domain for its own
        // duplicate check, which this backend does for itself.
        // Same rule as the coupon submit: only `merchantName` and `website`
        // are required, and blank optionals are omitted rather than sent as
        // empty strings.
        var json =
        {
            merchantName: name,
            website: merchantURL.val().toString(),
        };
        if (email) json.merchantEmail = email;
        if (mobileNumber) json.merchantPhone = mobileNumber;
        // Kept from .in: it doubles as a sanity check on the URL. Guarded,
        // though — `.match(...)[1]` throws on anything the pattern misses, and
        // an unparseable domain must not take the submit button down with it.
        let host = (new URL(merchantURL.val().toString())).hostname;
        let hostname = host.replace(/(^\w+:|^)\/\//, '');
        let domainMatch = hostname.match(/^(?:.*?\.)?([a-zA-Z0-9\-_]{3,}\.(?:\w{2,8}|\w{2,4}\.\w{2,4}))$/);
        var domain = domainMatch ? domainMatch[1] : hostname;

        var data = await request.post(apiBase() + '/submissions/merchant', json);
        // `{success, message}`, not a bare boolean — see the coupon submit.
        if (data && data.success) {
            const html = 'Thanks for submitting your Merchant. It will be posted after a quick review.'
            crowdSourcing.removeError(NewMerchantErrorParent);
            crowdSourcing.removeError(MerchantURLParetnt);
            crowdSourcing.removeError(submitButtonParent$);
            await setTimeoutAsync(1000);
            // (message, {type}) — this repo's signature. .in passes a title, an
                // India-CDN image and a flag; that image is not mirrored here and
                // the extra args are silently ignored, so the toast showed a
                // broken icon.
                ShowAlert(html);
            crowdSourcing.formClear(target);
            gaSC('Submit A Coupon','Merchant Submission');
        }
        else {
            NewMerchantErrorHtml = (data && data.message)
                || "Either You have already submitted Merchant or it is already exist!";
            crowdSourcing.showError(NewMerchantErrorHtml, submitButtonParent$);
        }
    })

    .on('keyup', '#mobileNumber', (e) => {        
        let mobileNumberParent$ = $('#submitmobileNumberRow');
        var mobile = $('#mobileNumber').val().toString();
        var phoneno = /^\d{10}$/;
        MobileNumberErrorParent = $('#mobileNumber').parent();
        if (!phoneno.test(mobile) && mobile != '') {
            MobileNumberError = true;
            MobileNumberErrorHtml = "Please provide 10  digit mobile number!";
            crowdSourcing.showError(MobileNumberErrorHtml, mobileNumberParent$);
        }
        else {
            MobileNumberError = false;
            crowdSourcing.removeError(MobileNumberErrorParent);
        }
    })

    .on('keyup', '#emailaddress', (e) => {        
        let emailParent$ = $('#submitemailRow');
        var emailAddress = $('#emailaddress').val().toString();
        var email = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        EmailErrorParent = $('#emailaddress').parent();
        if (!email.test(emailAddress) && emailAddress != '') {
            EmailError = true;
            EmailErrorHtml = "Please provide valid Email!";
            crowdSourcing.showError(EmailErrorHtml, emailParent$);
        }
        else {
            EmailError = false;
            crowdSourcing.removeError(EmailErrorParent);
        }
    })

/* Leader Board */
MainLeaderBoard(crowdSourcing.DateFilters);
